import SimpleTable from "@/components/SimpleTable";
import useProfile from "@/hooks/useProfile";
import { handleCompanyUserName } from "@/lib/handleName";
import { CompanyUser } from "@/schema/CompanyUser";
import MemberMenu from "@/src/app/(auth)/profile/_components/MemberCard/MemberMenu";
import { useTranslation } from "react-i18next";

interface MemberTableProps {
  members: CompanyUser[];
}

function MemberTable({ members }: MemberTableProps) {
  const { t } = useTranslation();
  const roles = [t("admin"), t("member")];
  const { profile, isRoleZero } = useProfile();

  return (
    <SimpleTable
      data={members}
      columns={[
        {
          key: "name",
          label: t("name"),
          render: ({ id, name: temp, name_kana, email }) => {
            const isMe = email === profile?.email;
            const name = handleCompanyUserName(id, temp);
            const username = name_kana ? name + " (" + name_kana + ")" : name;
            return isMe ? `${username} (You)` : username;
          },
        },
        {
          key: "email",
          label: t("email"),
          render: ({ email, phone_number }) => (
            <div className=" flex flex-col space-y-[2px]">
              <span>{email}</span>
              <span>{phone_number}</span>
            </div>
          ),
        },
        {
          key: "role",
          label: t("role"),
          render: ({ role }) => roles[role],
        },
        {
          key: "position",
          label: t("position"),
          render: ({ position }) => (position ? position : "--"),
        },
        {
          key: "department",
          label: t("department"),
          render: ({ department }) => (department ? department : "--"),
        },
        {
          key: "action",
          width: "200px",
          label: isRoleZero ? t("action") : "",
          render: (companyUser) => <MemberMenu member={companyUser} />,
        },
      ]}
    />
  );
}

export default MemberTable;
